/* ==========================================================================
   Yavru Patiler — Favoriler ❤️
   Heart toggles on puppy cards (SSR'd in Liquid), localStorage shortlist,
   floating rail button with count, popover panel, and a WhatsApp share that
   sends the whole shortlist to an expert. TR/EN via <html lang>. Idempotent.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'yp-favorites-v1';

  var UI = {
    tr: {
      add: 'Favorilere ekle',
      remove: 'Favorilerden çıkar',
      title: 'Beğendiklerim',
      empty: 'Henüz favori yok. Kalbe dokunarak minikleri buraya ekle. 🐾',
      view: 'Sayfasına git',
      removeItem: 'Çıkar',
      send: "Listemi WhatsApp'tan gönder",
      open: 'Beğendiklerim',
      close: 'Kapat',
      waMsg: 'Merhaba! Şu minikler ilgimi çekti: {names}. Müsaitlik durumlarını öğrenebilir miyim? 🐾'
    },
    en: {
      add: 'Add to favorites',
      remove: 'Remove from favorites',
      title: 'My favorites',
      empty: 'No favorites yet. Tap a heart to add pups here. 🐾',
      view: 'View page',
      removeItem: 'Remove',
      send: 'Send my list on WhatsApp',
      open: 'My favorites',
      close: 'Close',
      waMsg: 'Hi! These little ones caught my eye: {names}. Could you tell me about their availability? 🐾'
    }
  };

  function lang() {
    var l = (document.documentElement.getAttribute('lang') || 'tr').slice(0, 2).toLowerCase();
    return UI[l] ? l : 'tr';
  }
  function t() { return UI[lang()]; }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 40))); } catch (e) {}
  }
  function has(list, handle) { return list.some(function (x) { return x.handle === handle; }); }

  var state = { list: load(), rail: null, panel: null, listEl: null, count: null, wa: '' };

  /* ---- Heart buttons (rendered by Liquid: [data-fav]) ---- */
  function syncHearts(root) {
    (root || document).querySelectorAll('[data-fav]').forEach(function (btn) {
      var fav = has(state.list, btn.getAttribute('data-fav'));
      btn.classList.toggle('is-fav', fav);
      btn.setAttribute('aria-pressed', fav ? 'true' : 'false');
      btn.setAttribute('aria-label', fav ? t().remove : t().add);
    });
  }

  function toggle(btn) {
    var handle = btn.getAttribute('data-fav');
    var item = {
      handle: handle,
      title: btn.getAttribute('data-fav-title') || handle,
      url: btn.getAttribute('data-fav-url') || '#',
      breed: btn.getAttribute('data-fav-breed') || ''
    };
    if (has(state.list, handle)) {
      state.list = state.list.filter(function (x) { return x.handle !== handle; });
    } else {
      state.list.push(item);
      btn.classList.add('is-pop'); // little heartbeat
      setTimeout(function () { btn.classList.remove('is-pop'); }, 450);
    }
    save(state.list);
    syncHearts();
    renderRail();
  }

  function bindHearts(root) {
    (root || document).querySelectorAll('[data-fav]').forEach(function (btn) {
      if (btn.dataset.favInit) return;
      btn.dataset.favInit = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle(btn);
      });
    });
    syncHearts(root);
  }

  /* ---- Rail button + panel ---- */
  function waShareLink() {
    // one line per puppy, each with its page URL so the expert can open it instantly
    var names = state.list.map(function (x) {
      var line = x.title + (x.breed ? ' (' + x.breed + ')' : '');
      if (x.url) line += ' ' + location.origin + x.url;
      return line;
    }).join('\n');
    return 'https://wa.me/' + state.wa + '?text=' + encodeURIComponent(t().waMsg.replace('{names}', '\n' + names));
  }

  function renderPanelList() {
    var d = t();
    state.listEl.innerHTML = '';
    if (!state.list.length) {
      state.listEl.appendChild(el('p', 'fav-panel__empty', d.empty));
      state.send.style.display = 'none';
      return;
    }
    state.send.style.display = '';
    state.send.href = waShareLink();
    state.list.forEach(function (item) {
      var row = el('div', 'fav-panel__row');
      var a = el('a', 'fav-panel__name');
      a.href = item.url;
      a.textContent = item.title + (item.breed ? ' · ' + item.breed : '');
      var rm = el('button', 'fav-panel__remove');
      rm.type = 'button';
      rm.setAttribute('aria-label', d.removeItem + ': ' + item.title);
      rm.innerHTML = '&times;';
      rm.addEventListener('click', function () {
        state.list = state.list.filter(function (x) { return x.handle !== item.handle; });
        save(state.list);
        syncHearts();
        renderRail();
        renderPanelList();
      });
      row.appendChild(a);
      row.appendChild(rm);
      state.listEl.appendChild(row);
    });
  }

  function renderRail() {
    if (!state.rail) return;
    state.count.textContent = state.list.length;
    state.rail.classList.toggle('is-empty', state.list.length === 0);
    if (state.panel.classList.contains('is-open')) renderPanelList();
  }

  function buildRail() {
    var host = document.querySelector('.sticky-rail');
    if (!host || document.querySelector('[data-fav-rail]')) return;
    state.wa = (host.querySelector('[data-rail="whatsapp"]') || {}).href || '';
    state.wa = (state.wa.match(/wa\.me\/(\d+)/) || [])[1] || '';

    var d = t();
    var btn = el('button', 'sticky-rail__btn sticky-rail__btn--fav');
    btn.type = 'button';
    btn.setAttribute('data-fav-rail', '');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', d.open);
    btn.innerHTML = '<svg class="icon sticky-rail__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7-4.6-9.3-9A4.9 4.9 0 0 1 12 6.5 4.9 4.9 0 0 1 21.3 11C19 15.4 12 20 12 20Z"/></svg><span class="fav-count" aria-hidden="true">0</span><span class="sticky-rail__label">' + d.open + '</span>';

    var panel = el('div', 'fav-panel');
        panel.setAttribute('aria-label', d.title);
    var head = el('div', 'fav-panel__head');
    head.appendChild(el('strong', 'fav-panel__title', d.title));
    var close = el('button', 'fav-panel__close');
    close.type = 'button';
    close.setAttribute('aria-label', d.close);
    close.innerHTML = '&times;';
    head.appendChild(close);
    panel.appendChild(head);
    var listEl = el('div', 'fav-panel__list');
    panel.appendChild(listEl);
    var send = el('a', 'button button--clay fav-panel__send');
    send.target = '_blank';
    send.rel = 'noopener';
    send.textContent = d.send;
    panel.appendChild(send);

    function setOpen(open) {
      panel.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) renderPanelList();
    }
    btn.addEventListener('click', function () { setOpen(!panel.classList.contains('is-open')); });
    close.addEventListener('click', function () { setOpen(false); btn.focus(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) { setOpen(false); btn.focus(); }
    });

    host.insertBefore(btn, host.firstChild);
    host.appendChild(panel);
    state.rail = btn; state.panel = panel; state.listEl = listEl; state.count = btn.querySelector('.fav-count'); state.send = send;
    renderRail();
  }

  function init(root) {
    buildRail();
    bindHearts(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
